import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions } from '../Dialog/Dialog';
import { TextField } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import { addNewParty, getPartyList, emptyPartyList, tripExpenseTypes, addTripExpenseTypes, addChargeType, addDeductionType, getChargeTypes, getDeductionTypes } from "../../../store/actions/tripActionCreator";
import { editVendor } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import * as logger from "../../../logger";
import { trackDwebEvent } from '../../analytics';


const styles = makeStyles(theme => ({
    formRoot: {
        '& .MuiFormControl-root': {
            width: '100%',
            margin: '16px 0px'
        }
    },
    error: {
        color: 'red',
        marginBottom: 8
    },
    spanV1: {
        textTransform: 'capitalize'
    }
}))
const initialValues = {
    id: null,
    name: '',
    mobile: ''
}
const AddChargeDeductionType = (props) => {
    const { children, user, defaultId, defaultName, dispatchAddTripExpenseType, dispatchGetTripExpenseTypes, dispatchGetCharges, dispatchGetDeductions, dispatchAddChargeType, dispatchAddDeductionType, typeValue, classes, open, onClose, onSave, ...other } = props;

    const [dialogopen, setDialogOpen] = React.useState(open);
    const inlineStyles = styles();
    const { register, handleSubmit, control, errors } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            name: defaultName ? defaultName : '',
        },
    });

    const handleExpenseTypeSave = (e) => {
    }
    const handleClose = (status) => {
        setDialogOpen(false);
        onClose();
    };

    const onSubmit = values => {

        if (typeValue == "charges") {

            const chargeData = {
                name: values.name
            }

            dispatchAddChargeType(chargeData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Charge Deduction Type Dweb', 'Add Charge Type Successfull');
                        dispatchGetCharges(
                            (data) => {
                                if (data && data.status && data.status.code && data.status.code == 200) {
                                    logger.log('Add Charge Deduction Type Dweb', 'Get Charge Type Successfull');
                                    setDialogOpen(false);
                                    const typeData = {
                                        display: values.name,
                                        value: values.name
                                    }
                                    onSave(typeData);
                                }
                            },
                            () => {
                                logger.log('Add Charge Deduction Type Dweb', 'Get Charge Type Failed');
                            }
                        )
                    }
                },
                () => {
                    logger.log('Add Charge Deduction Type Dweb', 'Add Charge Type Failed');
                }
            );

        } else if (typeValue == "deduction") {

            const chargeData = {
                name: values.name
            }

            dispatchAddDeductionType(chargeData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Charge Deduction Type Dweb', 'Add Deduction Type Successfull');
                        dispatchGetDeductions(
                            (data) => {
                                if (data && data.status && data.status.code && data.status.code == 200) {
                                    logger.log('Add Charge Deduction Type Dweb', 'Get Deduction Type Successfull');
                                    setDialogOpen(false);
                                    const typeData = {
                                        display: values.name,
                                        value: values.name
                                    }
                                    onSave(typeData);
                                }
                            },
                            () => {
                                logger.log('Add Charge Deduction Type Dweb', 'Get Deduction Type Failed');
                            }
                        )
                    }
                },
                () => {
                    logger.log('Add Charge Deduction Type Dweb', 'Add Deduction Type Failed');
                }
            );

        }

    };
    return (
        <div>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogopen}>
                <DialogTitle id="add-party-dialog-title" onClose={handleClose}>
                    <span className={inlineStyles.spanV1}>{'Add ' + typeValue + ' Type'}</span>
                </DialogTitle>
                <DialogContent dividers>
                    <form className={inlineStyles.formRoot} onSubmit={handleExpenseTypeSave} noValidate id="hook-form" onSubmit={handleSubmit(onSubmit)}>
                        <TextField variant="outlined" size='small'
                            required={true} name="name"
                            label={typeValue == "deduction" ? "Deduction Type" : "Charge Type"}
                            placeholder={typeValue == "deduction" ? "Enter a Deduction Type" : "Enter a Charge Type"}
                            inputRef={register({
                                required: 'You must provide a Type name',
                                minLength: {
                                    value: 3,
                                    message: 'Type name must be greater than 3 characters',
                                },
                                validate: {
                                    spaceOnly: v => v.trim().length != 0,
                                }
                            })}
                            error={!!errors.name}
                            fullWidth
                            autoFocus
                        />
                        {errors?.name?.type === "spaceOnly" ? (
                            <span className={inlineStyles.error}>Alphabetical characters only</span>
                            ):errors && errors.name && (
                            <span className={inlineStyles.error}>{errors.name.message}</span>
                        )}
                    
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                        Close
                    </Button>
                    <Button type="submit" form="hook-form" variant="contained" className='modal-save-cta' onClick={handleExpenseTypeSave} >
                        Save changes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetTripExpenseTypes: (onSuccess, onFailure) => dispatch(tripExpenseTypes(onSuccess, onFailure)),
    dispatchAddTripExpenseType: (data, onSuccess, onFailure) => dispatch(addTripExpenseTypes(data, onSuccess, onFailure)),

    dispatchGetCharges: (onSuccess, onError) => {
        dispatch(getChargeTypes(onSuccess, onError))
    },
    dispatchGetDeductions: (onSuccess, onError) => {
        dispatch(getDeductionTypes(onSuccess, onError))
    },
    dispatchAddChargeType: (typeValue, onSuccess, onError) => {
        dispatch(addChargeType(typeValue, onSuccess, onError))
    },
    dispatchAddDeductionType: (typeValue, onSuccess, onError) => {
        dispatch(addDeductionType(typeValue, onSuccess, onError))
    }

});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddChargeDeductionType);